export const SITE = {
  name: "HRC Rénovation",
  owner: "Brandon Pouvit",
  siren: "904377660",
  phone: "06 41 96 83 46",
  phoneHref: "tel:+33641968346",
  email: "hrcrenovation24@gmail.com",
  address: "60 Ter Avenue du Général de Gaulle, BP 2769, 24660 Coulounieix-Chamiers",
  addressStreet: "60 Ter Avenue du Général de Gaulle, BP 2769",
  addressCity: "Coulounieix-Chamiers",
  addressZip: "24660",
  zone: "Dordogne, Lot, Corrèze, Haute-Vienne et Charente",
};

export const NAV_SERVICES = [
  { label: "Ravalement de façade", path: "/ravalement-facade" },
  { label: "Nettoyage & hydrofuge", path: "/nettoyage-hydrofuge" },
  { label: "Peinture int. & ext.", path: "/peinture" },
  { label: "Carrelage & maçonnerie", path: "/carrelage-maconnerie" },
];

export const CITIES_COL1 = ["Périgueux", "Coulounieix-Chamiers", "Sarlat", "Bergerac", "Boulazac", "Trélissac"];
export const CITIES_COL2 = ["Brive-la-Gaillarde", "Cahors", "Limoges", "Angoulême", "Terrasson", "Ribérac"];
export const ALL_CITIES = [...CITIES_COL1, ...CITIES_COL2];

export const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "@id": "https://hrcrenovation.fr/#business",
  name: "HRC Rénovation",
  telephone: "+33641968346",
  email: "hrcrenovation24@gmail.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "60 Ter Avenue du Général de Gaulle, BP 2769",
    addressLocality: "Coulounieix-Chamiers",
    postalCode: "24660",
    addressCountry: "FR",
  },
  areaServed: ["Dordogne", "Lot", "Corrèze", "Haute-Vienne", "Charente"],
  founder: "Brandon Pouvit",
  priceRange: "€€",
  openingHours: "Mo-Sa 08:00-19:00",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "7",
  },
};
